import React, { forwardRef, Ref } from 'react';

import { IconTypes } from '@eika/icon';

import Link, { BasicLinkProps } from '../Link';

interface IconLinkProps extends BasicLinkProps {
    icon: IconTypes;
    label?: string;
    children?: React.ReactNode;
}

const IconLink = forwardRef(
    ({ icon, label, children, ...rest }: IconLinkProps, ref: Ref<HTMLAnchorElement>): JSX.Element => {
        return (
            <Link {...rest} aria-label={label ?? rest['aria-label']} linkType="icon" icon={icon} ref={ref}>
                {children}
            </Link>
        );
    },
);

export default IconLink;
